<template lang="pug">
#checkoutComponent
  .container
    h2.checkout-title
      span.checkout-title__number 1
      span.checkout-title__text Xác nhận thông tin đơn hàng
    div.checkout-shipment
      div.checkout-shipment__restaurant
        CheckoutRestaurant()
      div.checkout-shipment__form
        CheckoutForm(:cart.sync="cart" :currentShipmentType="currentShipmentType")
    div.checkout-cart
      p.alert Lưu ý: Chúng tôi sẽ gọi lại cho bạn để xác nhận đơn hàng
      CartItems(:cart.sync="cart" :currentShipmentType="currentShipmentType")
    div.spacing.type-xs
    h2.checkout-title
      span.checkout-title__number 2
      span.checkout-title__text Chọn hình thức thanh toán

    div.checkout-payments(v-if="payments")
      div.checkout-payments__item(v-for="payment in payments" :class="'checkout-payments__' + payment.type.toLowerCase()")
        div
          label.field-radio(:for="'payment-type-'+ payment.id" @click="onSelectPayment(payment)")
            span.caption {{ payment.title }}
            span.hint(v-if="payment.description") {{ payment.description }}
            input( :id="'payment-type-'+ payment.id", type="radio", v-model="cart.payment" :value="payment.type")
            span.field-radio-button
          .checkout-payments__vnpay-options(v-if="payment.children && cart.payment === payment.type")
            .checkout-payments__vnpay-options__item(v-for="child in payment.children" @click="onSelectPaymentOption(payment,child)" :class="{'is-active': cart.payment_type === child.name}")
              component(:is="child.component")
              span.option-title {{ child.title }}
      div.checkout-submit
        button(@click.prevent="ordering(false)") xác nhận & Thanh toán
    // modal
    modal.modal-confirm(v-if='showTimeModal' @close='showTimeModal = true')
      h2(slot='header') Thông báo
      template(slot='body')
        p.alert.alert-danger
          | Hiện tại đã ngoài thời gian phục vụ của Sườn Mười. Thời gian phục vụ của Sườn Mười từ {{ openTime }} hàng ngày. Xin Quý khách vui lòng quay lại sau.
      template(slot='footer')
        .action
          button.btn.btn-remove(type='button' v-on:click='showTimeModal = false') Đóng
</template>

<script>

  import {mapGetters} from 'vuex'
  import {bus} from '../main'
  import Modal from './Modal.vue'

  import CartItems from "./CartItems";
  import CheckoutRestaurant from "./CheckoutRestaurant";
  import CheckoutForm from "./CheckoutForm";
  import VnPayQR from "./icons/VnPayQR";
  import VnPayATM from "./icons/VnPayATM";
  import VnPayVISA from "./icons/VnPayVISA";
  import VnPayWallet from "./icons/VnPayWallet";
  import _ from "lodash";

  export default {
    name: 'Checkout',
    components: {
      Modal,
      CheckoutForm,
      CheckoutRestaurant,
      CartItems,
      VnPayQR,
      VnPayATM,
      VnPayVISA,
      VnPayWallet,
    },
    computed: {
      ...mapGetters({
        'menus': 'restaurants/currentMenu',
        'products': 'restaurants/currentProducts',
        'timeDelivery': 'restaurants/timeDelivery',
        'currentRestaurant': 'restaurants/currentRestaurantPos',
        'currentShipmentType': 'shipments/currentShipmentType',
        'currentLocation': 'shipments/currentLocation',
        'payments': 'payments/allPayments',
      }),
    },
    data() {
      return {
        showModal: false,
        showTimeModal: false,
        openTime: null,
        cart: this.$cart,
        coupon_log_id: this.$cart.coupon_log_id || "",
        modalProduct: {
          active: false,
          activeId: 0,
          product: null,
          orderItem: null
        },
        loading: false,
        loadingVoucher: false,
        pos_selected: this.$foodbookConfig.pos_id,
        pos_options: [],
      };
    },
    mounted() {
    },
    created() {
      this.checkCartExpire();
      this.checkTimeOpenning();

      console.log(this.currentShipmentType)
      if (this.currentShipmentType && this.currentShipmentType.name) {
        if (this.currentShipmentType.name === 'pickup') this.cart.order_type = 'PICKUP'
        if (this.currentShipmentType.name === 'deli') this.cart.order_type = 'DELI'
      }

      bus.$on('checkCoupon', this.checkCoupon)
      bus.$on('removeCoupon', this.removeCoupon)
      bus.$on('updateSessionCart', this.updateSessionCart)

      this.$store.dispatch('payments/getAllPayments')

      this.getPosList();


      if (!this.cart.ordersItem.length) {
        //window.location.replace(this.$foodbookConfig.menupage);
        window.location.href = '/dat-mon/'
      }
      if (this.$foodbookConfig.user_phone) {
        this.$http.get(this.$foodbookConfig.wpapi + '/transactions', {
          params: {
            pos_parent: this.$foodbookConfig.pos_name,
            user_id: this.$foodbookConfig.user_phone
          }
        }).then(response => {
          if (response.body.data && response.body.data.count) {
            let delivery = _.filter(response.body.data.sale_logs, 'delivery_info');
            if (delivery.length) {
              let last_order = _.head(delivery);
              this.cart.username = last_order.membership_name;
              this.cart.user_id = this.convertMemberIdToPhone(last_order.membership_id);
              this.cart.to_address = last_order.delivery_info.address;
              this.cart.latitude = last_order.delivery_info.lat;
              this.cart.longitude = last_order.delivery_info.lng;
            } else {
              this.cart.user_id = this.convertMemberIdToPhone(this.$foodbookConfig.user_phone);
            }
          } else {
            this.cart.user_id = this.convertMemberIdToPhone(this.$foodbookConfig.user_phone);
          }
        }, response => {
          console.log("Error getOrderLog");
          this.cart.user_id = this.convertMemberIdToPhone(this.$foodbookConfig.user_phone);
        });
      }

      // location
      if (this.currentLocation) {
        this.currentLocation.lat && this.$set(this.$cart,'latitude', this.currentLocation.lat);
        this.currentLocation.lng && this.$set(this.$cart,'longitude', this.currentLocation.lng);
        this.currentLocation.address && this.$set(this.$cart,'to_address', this.currentLocation.address);
      }
      if (this.$cart.latitude && this.$cart.longitude) {
        this.calculateShipFee();
      }
    },
    filters: {},
    methods: {
      getMinutes(str) {
        let time = str.split(':');
        return time[0] * 60 + time[1] * 1;
      },
      getMinutesNow() {
        let timeNow = new Date();
        return timeNow.getHours() * 60 + timeNow.getMinutes();
      },
      checkTimeOpenning() {
        let n = new Date().getDay() + 1;
        if (this.timeDelivery) {
          let day = _.find(this.timeDelivery, ["Day_Of_Week", n])
          if (day && Object.keys(day).length) {
            let now = this.getMinutesNow();
            //now = this.getMinutes("22:40");
            let start = this.getMinutes(day.Time_Start);
            let end = this.getMinutes(day.Time_End);
            if (start > end) end += this.getMinutes('24:00');

            this.openTime = day.Time_Start + ' - ' + day.Time_End;

            if ((now >= start) && (now <= end)) {
              // your code here
              //console.log("Cửa hàng mở cửa!")
              this.showTimeModal = 0;
              return true;
            } else {
              console.log("Cửa hàng đóng cửa!")
              this.showTimeModal = 1;
              return false;
            }
          }
        }
      },
      checkCartExpire() {
        // const cs = this.$cookies.get('cart-session');
        //
        // if (cs !== 'uptime') {
        //   console.log('cleared session')
        //   localStorage.clear()
        //   sessionStorage.clear()
        //   this.$cookies.set('cart-session','uptime', "30MIN");
        // }
      },
      convertMemberIdToPhone(str) {
        if (typeof str == "number") str = str.toString();

        if (str.length != 11 && !str.startsWith('84')) {
          return false;
        } else {
          return str.replace('84', '0');
        }

        return false;
      },
      convertPhoneToMemberId(str) {

        if (str.length != 10 && !str.startsWith('0')) {
          return false;
        } else {
          return str.replace('0', '84');
        }

        return false;
      },
      changePosId(event) {

        if (event.target.value) {
          this.$foodbookConfig.pos_id = event.target.value;
        }

        if (this.$cart.latitude && this.$cart.longitude) {
          this.calculateShipFee();
        }
      },
      getPosList() {
        if (this.$foodbookConfig.pos_data) {
          let _arr = []
          _.forEach(this.$foodbookConfig.pos_data, function ($obj, $k) {
            _arr.push({text: $obj.Pos_Name, value: $obj.Id})
          })
          this.pos_options = _arr;
        }
      },
      getShortestDistance(data) {
        if (this.$foodbookConfig.pos_data) {

          function rad(x) {
            return x * Math.PI / 180;
          }

          function getDistance(p1, p2) {
            var R = 6378137; // Earth’s mean radius in meter
            var dLat = rad(p2.lat - p1.lat);
            var dLong = rad(p2.lng - p1.lng);
            var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) *
              Math.sin(dLong / 2) * Math.sin(dLong / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            var d = R * c;
            console.log('distance', d / 1000)
            return d; // returns the distance in meter
          }

          var _arr = [], min, pos, p1
          p1 = {
            lat: data.latitude,
            lng: data.longitude
          }
          _.forEach(this.$foodbookConfig.pos_data, function ($obj, $k) {
            let p2 = {
              lat: $obj.Pos_Latitude,
              lng: $obj.Pos_Longitude,
            }
            if (min == null || min >= getDistance(p1, p2)) {
              min = getDistance(p1, p2);
              pos = $obj
            }
          })
          //console.log('getShortestDistance',pos)
          if (pos) {
            this.pos_selected = pos.Id;
          }
        }
      },
      //Lay dia chi va lat lng
      setPlace(place) {
        if (place.geometry) {
          this.cart.to_address = place.formatted_address;
          this.cart.longitude = place.geometry.location.lng();
          this.cart.latitude = place.geometry.location.lat();
          console.log('setPlace', this.cart);
          this.getShortestDistance(this.cart);
          this.calculateShipFee();
        } else {
          this.cart.to_address = '';
          this.cart.longitude = null;
          this.cart.latitude = null;
          return;
        }
      },
      //Edit Order Item
      openModalProduct(p, index, orderItem) {
        this.modalProduct.product = p;
        this.modalProduct.activeId = index;
        this.modalProduct.orderItem = orderItem;
        this.modalProduct.active = true;

        this.toggleBodyClass('addClass', 'no-scrollbar')
      },
      closeModelProduct() {
        this.modalProduct.active = false;
        this.toggleBodyClass('removeClass', 'no-scrollbar')
        if (this.cart.coupon_log_id) {
          this.checkCouponUpdate();
        }
      },
      //Delete Cart item
      deleteCartItem(index) {
        this.cart.ordersItem.splice(index, 1);
        this.updateSessionCart();
        if (!this.cart.ordersItem.length) {
          window.location.replace(this.$foodbookConfig.menupage);
        }
      },
      //Update cart Item
      updateCart(order, product, index) {
        if (index > -1) {
          //Chinh sua gio hang
          this.$set(this.cart.ordersItem, index, {'order': order, 'product': product});
        } else {
          //Them moi
          this.cart.ordersItem.push({'order': order, 'product': product})
        }
        //Update session cart
        this.updateSessionCart();
        this.modalProduct.active = false;

      },
      //Update session cart
      updateSessionCart(data) {
        if (this.cart.coupon_log_id) {
          this.checkCouponUpdate();
        }
        this.calculateShipFee()
        localStorage.cart = JSON.stringify(this.cart);
      },
      //Tính shipment
      calculateShipFee() {
        // kiểm tra điểm bán tồn tại
        if (!(this.currentRestaurant && this.currentRestaurant.Id)) {
          this.$toasted.show("Điểm bán không hợp lệ", {
            position: "top-center",
            duration: 50000,
            type: 'error',
          });
          return;
        }


        //Tinh tong hoa don
        //totalPriceNotFormat
        let amount = 0;
        if (this.cart.ordersItem.length) {
          amount = this.$options.filters.totalPriceNotFormat(this.cart);
        }

        this.$http.get(this.$foodbookConfig.wpapi + '/ship', {
          params: {
            pos_id: this.currentRestaurant.Id,
            pos_parent: this.$foodbookConfig.pos_name,
            lng: this.cart.longitude,
            lat: this.cart.latitude,
            amount: amount
          }
        }).then(({data}) => {
          if (data && data.data && data.data.fee >=0) {
            this.$set(this.cart,'ship_price_real', data.data.fee)
            this.$set(this.cart,'distance', data.data.distance)
          }
        }, response => {
          //this.loading = false;
          //this.firstLoading = false;
        });
      },
      //Check coupon code
      checkCoupon() {
        this.coupon_log_id = this.cart.coupon_code || '';
        //Kiem tra ma coupon
        if (!this.coupon_log_id.trim()) {
          this.$toasted.show("Mã giảm giá không thể để trống", {
            position: "top-center",
            duration: 50000,
            type: 'error',
          });
          return;
        }

        //Kiem tra san pham trong gio hang
        if (!this.cart.ordersItem.length) {
          this.$toasted.show("Vui lòng chọn sản phẩm bạn muốn mua!", {
            position: "top-center",
            duration: 5000,
            type: 'error'
          });
          return;
        }

        //Check so dien thoai
        if (!this.cart.user_id || this.cart.user_id.length != 10 || !this.cart.user_id.startsWith('0')) {
          this.$toasted.show("Số điện thoại phải có 10 số và bắt đầu bằng số 0", {
            position: "top-center",
            duration: 5000,
            type: 'error'
          });
          return;
        }
        if (this.cart.user_id.substring(0, 1) !== '0') {
          this.$toasted.show("Số điện thoại không chính xác, phải bắt đầu bằng số 0 (ví dụ: 09xxxxxxx)", {
            position: "top-center",
            duration: 5000,
            type: 'error',
          });
          return;
        }


        //Render ra san pham
        let order_data_item = this.$options.filters.renderOrderItems(this.cart);
        this.cart.coupon_status = 'processing';
        if (!this.currentRestaurant) {
          this.$toasted.show("Có lỗi không chọn nhà hàng !!?", {
            position: "top-center",
            duration: 5000,
            type: 'error'
          });
          return;
        }

        this.$http.get(this.$foodbookConfig.wpapi + '/coupon', {
          params: {
            pos_id: this.currentRestaurant.Id,
            pos_parent: this.$foodbookConfig.pos_name,
            voucher_code: this.coupon_log_id,
            membership_id: this.convertPhoneToMemberId(this.cart.user_id),
            order_data_item: order_data_item
          }
        }).then(response => {
          response.log
          if (response.body.error) {
            this.$toasted.show(response.body.error.message, {
              position: "top-center",
              duration: 5000,
              type: 'error'
            });
            this.cart.Discount_Amount = null;
            this.cart.coupon_status = 'error';
          } else {
            if (response.body.data && response.body.data.Code === 4) {
              this.cart.coupon_log_id = this.coupon_log_id;
              this.cart.Discount_Amount = response.body.data.Discount_Amount;
              this.cart.coupon_status = 'valid';
              localStorage.cart = JSON.stringify(this.cart);

            } else {
              this.$toasted.show("Mã giảm giá không hợp lệ", {
                position: "top-center",
                duration: 5000,
                type: 'error'
              });
              this.cart.Discount_Amount = null;
              this.cart.coupon_status = 'invalid';
            }
          }
          this.loadingVoucher = false;
        }, response => {
          this.$toasted.show('Không thể kiểm tra mã giảm giá', {
            position: "top-center",
            duration: 5000,
            type: 'error'
          });
          this.cart.Discount_Amount = null;
          this.loadingVoucher = false;
          this.cart.coupon_status = '';
        });
      },
      checkCouponUpdate() {
        this.coupon_log_id = this.cart.coupon_code || '';
        //Kiem tra ma coupon
        if (!this.coupon_log_id.trim()) {
          this.cart.Discount_Amount = null;
          this.cart.coupon_log_id = null;
          return;
        }

        //Kiem tra san pham trong gio hang
        if (!this.cart.ordersItem.length) {
          this.cart.Discount_Amount = null;
          this.cart.coupon_log_id = null;
          return;
        }

        //Check so dien thoai
        if (!this.cart.user_id || this.cart.user_id.length !== 10) {
          this.cart.Discount_Amount = null;
          this.cart.coupon_log_id = null;
          return;
        }
        if (this.cart.user_id.substring(0, 1) !== '0') {
          this.cart.Discount_Amount = null;
          this.cart.coupon_log_id = null;
          return;
        }

        //Render ra san pham
        this.loadingVoucher = true;
        let order_data_item = this.$options.filters.renderOrderItems(this.cart);

        if (!this.currentRestaurant) {
          return;
        }

        this.$http.get(this.$foodbookConfig.wpapi + '/coupon', {
          params: {
            pos_id: this.currentRestaurant.Id,
            pos_parent: this.$foodbookConfig.pos_name,
            voucher_code: this.coupon_log_id,
            membership_id: this.convertPhoneToMemberId(this.cart.user_id),
            order_data_item: order_data_item
          }
        }).then(response => {
          if (response.body.error) {
            this.$toasted.show(response.body.error.message, {
              position: "top-center",
              duration: 5000,
              type: 'error'
            });
            this.cart.Discount_Amount = null;
            this.cart.coupon_log_id = null;
            localStorage.cart = JSON.stringify(this.cart);
            this.cart.coupon_status = 'error';
          } else {
            if (response.body.data && response.body.data.Code === 4) {
              this.cart.coupon_log_id = this.coupon_log_id;
              this.cart.Discount_Amount = response.body.data.Discount_Amount;
              localStorage.cart = JSON.stringify(this.cart);
              this.cart.coupon_status = 'valid';
            } else {
              this.$toasted.show("Mã giảm giá không hợp lệ", {
                position: "top-center",
                duration: 5000,
                type: 'error'
              });
              this.cart.coupon_log_id = null;
              this.cart.Discount_Amount = null;
              localStorage.cart = JSON.stringify(this.cart);
              this.cart.coupon_status = 'invalid';
            }
          }
          this.loadingVoucher = false;
        }, response => {
          this.$toasted.show('Không thể kiểm tra mã giảm giá', {
            position: "top-center",
            duration: 5000,
            type: 'error'
          });
          this.cart.Discount_Amount = null;
          this.loadingVoucher = false;
          this.cart.coupon_status = 'error';
        });
      },
      removeCoupon() {
        this.cart.coupon_status = null
        this.cart.coupon_code = ''
        this.coupon_log_id = ''
        this.checkCouponUpdate();
        localStorage.cart = JSON.stringify(this.cart);
      },
      //Kiem tra thong tin
      async checkCart() {
        //console.log(this.cart);
        if (this.checkTimeOpenning() === false) {
          return;
        }
        //console.log(this.checkTimeOpenning());
        //Kiem tra thong tin truoc khi dat hang
        if (!this.cart.to_address) {
          this.$toasted.show("Địa chỉ của bạn không hợp lệ !", {
            position: "top-center",
            duration: 5000,
            type: 'error'
          });
          return;
        }
        if (!this.cart.latitude || !this.cart.longitude) {
          this.$toasted.show("Địa điểm giao hàng không thể được xác định", {
            position: "top-center",
            duration: 5000,
            type: 'error'
          });
          return;
        }
        if (!this.cart.user_id || this.cart.user_id.length != 10 || !this.cart.user_id.startsWith('0')) {
          this.$toasted.show("Số điện thoại không hợp lệ", {
            position: "top-center",
            duration: 5000,
            type: 'error'
          });
          return;
        }
        if (!this.cart.username) {
          this.$toasted.show("Nhập tên của bạn", {
            position: "top-center",
            duration: 5000,
            type: 'error'
          });
          return;
        }
        if (!this.cart.ordersItem.length) {
          this.$toasted.show("Không có sản phẩm trong giỏ hàng", {
            position: "top-center",
            duration: 5000,
            type: 'error'
          });
          return;
        }
        if (!this.cart.payment) {
          this.$toasted.error("Vui lòng chọn phương thức thanh toán", {duration: 5000});
        }
        localStorage.cart = JSON.stringify(this.cart);
        this.showModal = true;
      },
      //Dat hang
      ordering(payment = false) {
        let amount = 0;
        let {Id: _posId} = this.currentRestaurant;

        if (!this.currentRestaurant) {
          return this.$toasted.show('Thiếu thông tin điểm bán hàng!', {
            position: "top-center",
            duration: 8000,
            type: 'error'
          });
        }

        if (!this.currentShipmentType || !this.currentShipmentType.name) {
          return this.$toasted.show('Thiếu thông tin cách nhận/giao hàng', {
            position: "top-center",
            duration: 8000,
            type: 'error'
          });
        }

        if (this.currentShipmentType && this.currentShipmentType.name === 'delivery') {
          if (!this.cart.to_address) {
            return this.$toasted.show('Bạn cần chọn điểm giao hàng !', {
              position: "top-center",
              duration: 8000,
              type: 'error'
            });
          }
        }

        if (!this.cart.username) {
          return this.$toasted.show('Bạn cần nhập Tên người nhận', {
            position: "top-center",
            duration: 8000,
            type: 'error'
          });
        }

        if (!this.cart.user_id) {
          return this.$toasted.show('Bạn cần nhập Số điện thoại', {
            position: "top-center",
            duration: 8000,
            type: 'error'
          });
        }
        let {delivery_time_type} = this.cart
        if (delivery_time_type && delivery_time_type.trim() === 'Hẹn giờ giao hàng') {
          if (!this.cart.delivery_time_date || !this.cart.delivery_time_hour)
            return this.$toasted.show('Bạn đã chọn Hẹn giờ giao hàng, bạn cần chọn ngày và giờ hẹn!', {
              position: "top-center",
              duration: 8000,
              type: 'error'
            });
        }


        if (!this.cart.payment) {
          return this.$toasted.show('Bạn cần chọn phương thức thanh toán', {
            position: "top-center",
            duration: 8000,
            type: 'error'
          });
        }
        if ('VnPay' === this.cart.payment && !this.cart.payment_type) {
          return this.$toasted.show('Bạn cần chọn ngân hàng/thẻ của cổng thanh toán của VnPay', {
            position: "top-center",
            duration: 8000,
            type: 'error'
          });
        }

        if (this.cart.ordersItem.length) {
          amount = this.$options.filters.totalPriceNotFormat(this.cart);
        }
        let order_data_item = this.$options.filters.renderOrderItems(this.cart);

        let ship_price_real = 0;

        if (this.cart.order_type === 'DELI' || this.cart.order_type === 'DELIAT') {
          ship_price_real = this.cart.ship_price_real
        }

        let order = {
          pos_id: _posId,
          pos_parent: this.$foodbookConfig.pos_name,
          adapt_to_online: 0,
          coupon_log_id: this.cart.coupon_log_id,
          user_id: this.convertPhoneToMemberId(this.cart.user_id),
          username: this.cart.username,
          note: this.cart.note,
          longitude: this.cart.longitude,
          latitude: this.cart.latitude,
          distance: this.cart.distance,
          to_address: this.cart.to_address,
          ship_price_real,
          amount: amount,
          total_amount: amount,
          order_type: this.cart.order_type || 'DELI',
          order_data_item: order_data_item,
          PaymentInfo: {
            Payment_Method: "PAYMENT_ON_DELIVERY",
            Payment_Info: "1",
            Amount: 0
          },
          Discount_Amount: this.cart.Discount_Amount,
          is_estimate:1, // Kiểm hàng chứ ko tạo đơn
          delivery_time: { // thời điểm giao hàng
            type: this.cart.delivery_time_type,
            date: this.cart.delivery_time_date,
            hour: this.cart.delivery_time_hour,
          },
        };
        let restaurant,shipment;
        if (this.currentRestaurant) {
          restaurant = {
            name: this.currentRestaurant.Pos_Name,
            address: this.currentRestaurant.Pos_Address,
          }
        }
        order = {
          ...order,
          restaurant
        }

        if (this.currentShipmentType) {
          shipment = this.currentShipmentType
          if ('pickup' === shipment.name) {
            this.cart.order_type = 'PICK'
            order.order_type = 'PICK'
          }
        }

        if (this.currentShipmentType) {
          shipment = this.currentShipmentType
          if ('pickup' === shipment.name) {
            this.cart.order_type = 'PICK'
            order.order_type = 'PICK'
          }
        }

        if (order.order_type === 'PICK') {
          if (!order.delivery_time.date) {
            return this.$toasted.show('Thiếu thông tin Ngày lấy hàng', {
              position: "top-center",
              duration: 8000,
              type: 'error'
            });
          }
          if (!(order.delivery_time.hour) ) {
            return this.$toasted.show('Thiếu thông tin Giờ lấy hàng', {
              position: "top-center",
              duration: 8000,
              type: 'error'
            });
          } else {
            if (typeof order.delivery_time === "object") {
              if ((order.delivery_time.hour.HH < 9 ) || (order.delivery_time.hour.HH >21)) {
                return this.$toasted.show('Thông tin Giờ lấy hàng không đúng', {
                  position: "top-center",
                  duration: 8000,
                  type: 'error'
                });
              }

              if (typeof order.delivery_time.hour === "string") {
                let arr = order.delivery_time.hour.split(':');
                let hour = {};
                if (arr[0]) {
                  hour.HH = arr[0];
                } else {
                  return this.$toasted.show('Sai thông tin Giờ lấy hàng', {
                    position: "top-center",
                    duration: 8000,
                    type: 'error'
                  });
                }
                hour.mm = arr[1] ? arr[1] : "0";

              } else if (typeof order.delivery_time.hour === "object") {
                if (!order.delivery_time.hour.HH) {
                  return this.$toasted.show('Sai thông tin Giờ lấy hàng', {
                    position: "top-center",
                    duration: 8000,
                    type: 'error'
                  });
                }
                if (!order.delivery_time.hour.mm) order.delivery_time.hour.mm = 0;
              }

            }

          }

        }

        order = {
          ...order,
          shipment
        }
        // console.log('order', order);
        // return;
        // console.log('order',order); return ;
        // console.log(order,this.cart.payment)
        // return
        // VnPay hoặc COD
        if (this.cart.payment === "VnPay") {
          let amountVnpay = 0;
          if (this.cart.ordersItem.length) {
            amountVnpay = this.$options.filters.totalPricePayment(this.cart);
          }
          order.PaymentInfo.Payment_Method = "VNPAY_OD_ONLINE";
          order.PaymentInfo.Amount = amountVnpay;
        }else if (this.cart.payment === "MOMO") {
          let amountVnpay = 0;
          if (this.cart.ordersItem.length) {
            amountVnpay = this.$options.filters.totalPricePayment(this.cart);
            order.PaymentInfo.Amount = amountVnpay;
          }
          order.PaymentInfo.Payment_Method = "MOMO_OD_ONLINE";
        }else if (this.cart.payment === "ZaloPay") {
          let amountVnpay = 0;
          if (this.cart.ordersItem.length) {
            amountVnpay = this.$options.filters.totalPricePayment(this.cart);
            order.PaymentInfo.Amount = amountVnpay;
          }
          order.PaymentInfo.Payment_Method = "ZALOPAY_OD_ONLINE";
        }


        // avoid old data type
        if (this.cart.payment === "COD" || this.cart.payment === "offline") {
          this.cart.payment = 'PAYMENT_ON_DELIVERY';
          order.PaymentInfo.Payment_Method = "PAYMENT_ON_DELIVERY";
        }

        if ('TRANSFER' === this.cart.payment) {
          order.PaymentInfo.Payment_Method = "TRANSFER";
        }
        this.cart.PaymentInfo.Payment_Method = order.PaymentInfo.Payment_Method

        if (this.cart.booking_info) {
          _.assign(order, {'booking_info': this.cart.booking_info});
        }

        this.loading = true;
        this.$http.post(this.$foodbookConfig.wpapi + '/orders', order).then(({data}) => {
          if (data.error) {
            this.$toasted.show(data.error.message.replace(/TrackId:(.*)/,'.'), {
              position: "top-center",
              duration: 5000,
              type: 'error'
            });
          } else {
            if (data && data.link ) {
              //TODO: cần xóa dữ liệu cart cũ
              localStorage.removeItem('vuex')
              localStorage.removeItem('cart')
              window.location.href = data.link
            }
          }

          this.loading = false;
        }, response => {
          this.$toasted.show('Xin lỗi, đã có lỗi xảy ra! Bạn đã đặt hàng không thành công!', {
            position: "top-center",
            duration: 5000,
            type: 'error'
          });
          this.loading = false;
        });
      },
      gotoShop() {
        window.location.replace(this.$foodbookConfig.menupage);
      },
      sortObject(o) {
        let sorted = {},
          key, a = [];

        for (key in o) {
          if (o.hasOwnProperty(key)) {
            a.push(key);
          }
        }

        a.sort();

        for (key = 0; key < a.length; key++) {
          sorted[a[key]] = o[a[key]];
        }
        return sorted;
      },
      toggleBodyClass(addRemoveClass, className) {
        const el = document.body;

        if (addRemoveClass === 'addClass') {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      },

      onSelectPayment(payment) {
        this.$set(this.cart,'payment', payment.type )
        this.$set(this.cart,'payment_type', null )
        localStorage.cart = JSON.stringify(this.cart);
      },
      onSelectPaymentOption(payment,type) {
        this.$set(this.cart,'payment_type', type.name )
        localStorage.cart = JSON.stringify(this.cart);
      },
    }, // methods
  }
</script>



// WEBPACK FOOTER //
// src/components/Checkout.vue